import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { Constants } from 'src/app/shared';

@Component({
  selector: 'app-energy-dashboard',
  templateUrl: './energy-dashboard.component.html',
  styleUrls: ['./energy-dashboard.component.scss']
})
export class EnergyDashboardComponent implements OnInit, OnDestroy {
  @ViewChild('tabs') tabs: MatTabGroup;
  siteId: string;
  activeTabIndex = 0;
  subTabs = [];
  PER_ENERGY_DASHBOARD = true;
  PER_ENERGY_LOADONTREE = true;
  PER_ENERGY_TESTBENCH = true;
  PER_ENERGY_REALTIMEPOWER = true;
  PER_ENERGY_SPECIFICENERGY = true;
  PER_ENERGY_METERVIEW = true;
  PER_ENERGY_TRANSFORMERMONITORING = true;
  PER_ENERGY_TRANSFORMERDASHBOARD = true;
  PER_ENERGY_DEEPDIVE = true;
  PER_ENERGY_NOTIFICATIONS = true;
  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private location: Location,
    private authService: AuthService
  ) {
    this.PER_ENERGY_DASHBOARD = authService.doAuthorization([
      Constants.ACTIVITY.ENERGY_DASHBOARD
    ]);
    this.PER_ENERGY_LOADONTREE = authService.doAuthorization([
      Constants.ACTIVITY.LOAD_ON_TREE_VIEW
    ]);
    this.PER_ENERGY_TESTBENCH = authService.doAuthorization([
      Constants.ACTIVITY.TESTBENCH_OVERVIEW
    ]);
    this.PER_ENERGY_REALTIMEPOWER = authService.doAuthorization([
      Constants.ACTIVITY.REAL_TIME_INFORMATION
    ]);
    this.PER_ENERGY_SPECIFICENERGY = authService.doAuthorization([
      Constants.ACTIVITY.SPECIFIC_ENERGY
    ]);
    this.PER_ENERGY_METERVIEW = authService.doAuthorization([
      Constants.ACTIVITY.METER_VIEW
    ]);
    this.PER_ENERGY_TRANSFORMERMONITORING = authService.doAuthorization([
      Constants.ACTIVITY.TRANSFORMER_MONITORING_VIEW
    ]);
    this.PER_ENERGY_TRANSFORMERDASHBOARD = authService.doAuthorization([
      Constants.ACTIVITY.TRANSFORMER_DASHBOARD
    ]);
    this.PER_ENERGY_DEEPDIVE = authService.doAuthorization([
      Constants.ACTIVITY.DEEP_DIVE_INFORMATION
    ]);
    this.PER_ENERGY_NOTIFICATIONS = authService.doAuthorization([
      Constants.ACTIVITY.NOTIFICATIONS
    ]);
    this.subTabs = [
      {
        id: 'enery-dashboard-id',
        label: 'Dashboard',
        path: 'energy',
        disable: !this.PER_ENERGY_DASHBOARD
      },
      {
        id: 'load-on-tree-id',
        label: 'Load On Tree',
        path: 'load-on-tree',
        disable: !this.PER_ENERGY_LOADONTREE
      },
      {
        id: 'real-time-id',
        label: 'RealTimePower Trends',
        path: 'real-time',
        disable: !this.PER_ENERGY_REALTIMEPOWER
      },
      {
        id: 'deep-dive-id',
        label: 'Deep Dive',
        path: 'deep-dive',
        disable: !this.PER_ENERGY_DEEPDIVE
      },
      {
        id: 'notifications-id',
        label: 'Notifications',
        path: 'notifications',
        disable: !this.PER_ENERGY_NOTIFICATIONS
      },
      {
        id: 'testbench-overview-id',
        label: 'TestBench OverView',
        path: 'testbench-overview',
        disable: !this.PER_ENERGY_TESTBENCH
      },
      {
        id: 'specific-energy-id',
        label: 'Specific Energy',
        path: 'specific-energy',
        disable: !this.PER_ENERGY_SPECIFICENERGY
      },
      {
        id: 'meter-view-id',
        label: 'Meter View',
        path: 'meter-view',
        disable: !this.PER_ENERGY_METERVIEW
      },
      {
        id: 'transformer-monitoring-id',
        label: 'TransformerMonitoring',
        path: 'transformer-monitoring',
        disable: !this.PER_ENERGY_TRANSFORMERMONITORING
      },
      {
        id: 'transformer-dashboard-id',
        label: 'TransformerDashboard',
        path: 'transformer-dashboard',
        disable: !this.PER_ENERGY_TRANSFORMERDASHBOARD
      }
    ];
  }

  ngOnInit() {
    // Combine them both into a single observable
    const urlParams = combineLatest(
      this.activeRoute.params,
      this.activeRoute.queryParams,
      (params, queryParams) => ({ ...params, ...queryParams })
    );

    // Subscribe to the single observable, giving us both
    urlParams.subscribe((routeParams) => {
      this.siteId = routeParams.siteId;
    });

    // Update selected tab base on URL - In case user use Back - Next button on browser.
    this.location.subscribe(() => {
      let currentLocation = this.location.path(true);
      if (
        currentLocation &&
        currentLocation.indexOf('/site/energy-dashboard/') >= 0
      ) {
        currentLocation = currentLocation.replace(
          '/site/energy-dashboard/',
          ''
        );
        currentLocation = currentLocation.substr(
          0,
          currentLocation.indexOf('?')
        );

        if (currentLocation && currentLocation.length > 0) {
          this.getCurrentLocation(currentLocation);
        }
      }
    });
    if (this.siteId === 'TATAThen625564' || this.siteId === 'CUMMDarlDL1468') {
      this.subTabs.splice(5, this.subTabs.length - 1);
    }
    this.setTabOnLoad();
  }
  getCurrentLocation(urlPath) {
    for (let i = 0; i < this.subTabs.length; i++) {
      if (this.subTabs[i].path === urlPath) {
        this.activeTabIndex = i;
        break;
      }
    }
  }

  setTabOnLoad() {
    const urlTree = this.router.parseUrl(this.router.url);
    urlTree.queryParams = {};
    const path = urlTree.toString().split('/');
    this.getCurrentLocation(path[path.length - 1]);
  }
  ngOnDestroy() {}

  navigate($event: MatTabChangeEvent) {
    const tab = this.subTabs[$event.index];
    this.router.navigate(['site/energy-dashboard/', tab.path], {
      queryParams: { siteId: this.siteId }
    });
  }
}
